"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultReporter = getDefaultReporter;
exports.logDebug = logDebug;
exports.logError = logError;
exports.logWarning = logWarning;
exports.reportEvent = reportEvent;
exports.reportLog = reportLog;
const debug = false;
const forceReport = false;
const report_1 = require("./report");
const defaultReporter = new report_1.OKXReporter();
function getDefaultReporter() {
    return defaultReporter;
}
const packageJson = require('../../package.json');
const version = packageJson.version;
function logDebug(...args) {
    if (typeof console != 'undefined') {
        try {
            if (debug || (window === null || window === void 0 ? void 0 : window.okxLogDebug)) {
                console.log(`[OKX_CONNECT_SDK] ${version} `, ...args);
            }
        }
        catch (_a) { }
    }
}
function logError(...args) {
    if (typeof console != 'undefined') {
        try {
            if (debug || (window === null || window === void 0 ? void 0 : window.okxLogDebug)) {
                console.error(`[OKX_CONNECT_SDK] ${version} `, ...args);
            }
            if (forceReport || !debug) {
                let content = '';
                content += [...args].reduce((result, item) => {
                    if (typeof item == 'string') {
                        result += ',' + item;
                    }
                    else if (typeof item == 'object') {
                        result += JSON.stringify(item);
                    }
                });
                defaultReporter.sendRecordContent(content, report_1.OKXReportType.LOG, '');
            }
        }
        catch (_a) { }
    }
}
function logWarning(...args) {
    if (typeof console != 'undefined') {
        try {
            if (debug || (window === null || window === void 0 ? void 0 : window.okxLogDebug)) {
                console.warn(`[OKX_CONNECT_SDK] ${version} `, ...args);
            }
        }
        catch (_a) { }
    }
}
function reportEvent(type, action, content) {
    return __awaiter(this, void 0, void 0, function* () {
        yield defaultReporter.sendRecordContent(content, type, action);
    });
}
function reportLog(content_1) {
    return __awaiter(this, arguments, void 0, function* (content, action = 'default') {
        // await defaultReporter.sendRecordContent(content, OKXReportType.LOG, action)
    });
}
